import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useCallback, useRef } from 'react';
import { BackInfoActions } from '../../Reducer/BackInfoReducer';
import { useSelector } from 'react-redux';

/**
 * navigate 래퍼 훅
 * 페이지 이동 시 현재 경로를 BackStack에 자동으로 push
 *
 * replace: true 인 경우는 push 안 함
 *
 * @example
 * const { navigate } = useAppNavigate();
 * navigate('/M_WorkInfo');        // 스택에 현재 경로 push 후 이동
 * navigate('/Home', { replace: true }); // 스택 push 없이 이동
 */
export function useAppNavigate() {
  const router = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { stack } = useSelector((state) => state.backInfo);
  const counterRef = useRef(0);

  const navigate = useCallback(
    (to, options = {}) => {
      if (typeof to !== 'number' && !options?.replace) {
        counterRef.current += 1;
        dispatch(
          BackInfoActions.push({
            id: `page_${Date.now()}_${counterRef.current}`,
            type: 'page',
            path: location.pathname,
          })
        );
      }
      router(to, options);
    },
    [router, location, dispatch]
  );

  // BackStack 기준으로 이전 페이지로 이동
  const popPage = useCallback(() => {
    for (let i = stack.length - 1; i >= 0; i--) {
      if (stack[i].type === 'page') {
        const path = stack[i].path;
        dispatch(BackInfoActions.popPage());
        router(path);
        return;
      }
    }
  }, [stack, dispatch, router]);

  return { navigate, popPage };
}
